import React from "react";

const InsightItem = ({ title, color }) => {
  return (
    <div className={`flex w-full p-3 ${color} my-3 rounded-lg`}>
      <div className="mr-5">
        <svg
          className="w-6 h-6"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_3444_4162)">
            <path
              d="M16.9121 1.60621C14.0598 -0.545127 9.83883 -0.56097 6.95343 1.7135C3.10067 4.75049 2.46205 11.0025 6.76485 14.5377V18.6735C6.76485 19.7854 7.61887 20.8494 9.04251 20.8494C9.04251 22.8739 10.5048 24 11.9968 24C13.4824 24 14.9511 22.8829 14.9511 20.8494C16.3502 20.8494 17.2287 19.8086 17.2287 18.6735V14.5378C21.5846 10.96 20.8825 4.60096 16.9121 1.60621ZM11.9969 22.3258C11.3594 22.3258 10.7167 21.8872 10.7167 20.8494H13.277C13.2769 21.8349 12.6847 22.3258 11.9969 22.3258ZM15.5547 18.6735C15.5546 18.9501 15.3296 19.1753 15.0529 19.1753C14.3555 19.1753 9.5903 19.1753 8.94084 19.1753C8.66414 19.1753 8.43904 18.9502 8.43904 18.6735V17.6997H15.5547V18.6735ZM15.8921 13.4583C15.6798 13.6163 15.5547 13.8654 15.5547 14.13V16.0256H12.834V12.1177L14.8675 8.59542C15.0986 8.19506 14.9615 7.68314 14.5611 7.452C14.1607 7.22086 13.6487 7.35801 13.4177 7.75837L11.997 10.2193L10.5762 7.75837C10.3451 7.35801 9.83306 7.22086 9.43275 7.452C9.03239 7.68319 8.89523 8.19511 9.12637 8.59542L11.1599 12.1177V16.0257H8.43918V14.1301C8.43918 13.8654 8.31403 13.6164 8.10173 13.4584C4.33105 10.6536 4.89163 5.47068 7.99007 3.0283C10.2474 1.24878 13.6383 1.23378 15.9041 2.9428C19.0895 5.34557 19.714 10.6156 15.8921 13.4583Z"
              fill="#3B3A44"
            />
          </g>
          <defs>
            <clipPath id="clip0_3444_4162">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </div>
      <div>{title}</div>
    </div>
  );
};

export default InsightItem;
